"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

export function LookupForm() {
  const router = useRouter();
  const [value, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    const raw = value.trim();
    if (!raw) {
      setError("请输入订单号 / Please enter your order number");
      return;
    }
    const digitsOnly = raw.replace(/^#/, "").replace(/\s+/g, "");
    if (!/^\d+$/.test(digitsOnly)) {
      setError("订单号格式应为数字，例如 1064 或 #1064");
      return;
    }
    setError("");
    setSubmitting(true);
    const encoded = encodeURIComponent(raw);
    router.push(`/track/${encoded}`);
  }

  return (
    <form
      action="/track"
      method="get"
      onSubmit={handleSubmit}
      className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-8"
    >
      <label htmlFor="orderNumber" className="block text-sm font-medium text-slate-700 mb-2">
        订单号 / Order Number
      </label>
      <input
        id="orderNumber"
        name="q"
        type="text"
        inputMode="numeric"
        autoComplete="off"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="例如 / e.g. 1064 or #1064"
        className="w-full px-4 py-3 border border-slate-300 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        autoFocus
      />
      <p className="text-xs text-slate-500 mt-2">
        Shopify 订单号（在您的下单确认邮件里，例如 #1064）或预订单编号
      </p>

      {error && (
        <p className="text-sm text-red-600 mt-3">{error}</p>
      )}

      <button
        type="submit"
        disabled={submitting}
        className="w-full mt-5 px-4 py-3 bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-medium rounded-lg transition-colors"
      >
        {submitting ? "跳转中... / Loading..." : "查询订单状态 / Look Up Order"}
      </button>
    </form>
  );
}
